export default {
  'team_authentications.save.error':
    'There was an error while saving your Team Authentication. Please try again later.'
}
